import PropTypes from 'prop-types';
import React from 'react';
import { formatCurrency } from '../../utilities.js';
import { CartRow } from './cart_row.jsx';

export const CartItem = ({ item, currency }) => {
  return (
    <CartRow
      label={`${item.quantity}x ${item.name}`}
      right={formatCurrency(item.total, currency)}
    />
  )
}

CartItem.propTypes = {
  item: PropTypes.object,
  currency: PropTypes.string,
}
